import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import tipsService from "../services/tipsService";

const initialState = {
  tips: [],
  error: false,
  success: false,
  loading: false,
  message: null,
};

export const add = createAsyncThunk(
  "tips/add",
  async (tip, thunkAPI) => {
    const data = await tipsService.add(tip);

    // Check for errors
    if (data.errors) {
      return thunkAPI.rejectWithValue(data.errors[0]);
    }

    return data;
  }
);

export const getTipsByChallengeId = createAsyncThunk(
  "tips/get",
  async (id, thunkAPI) => {
    const data = await tipsService.getTipsByChallengeId(id);

    return data;
  }
);

export const getTipById = createAsyncThunk(
  "tips/purchased",
  async (data, thunkAPI) => {
    const res = await tipsService.getTipById(data);

    return res;
  }
);

export const getTipsIndexByChallengeId = createAsyncThunk(
  "tips/getIndex",
  async (id, thunkAPI) => {
    const data = await tipsService.getTipsIndexByChallengeId(id);

    return data;
  }
);

export const deleteTipsById = createAsyncThunk(
  "tips/delete",
  async (id, thunkAPI) => {
    const data = await tipsService.deleteTipsById(id);

    return data;
  }
);

export const tipsSlice = createSlice({
  name: "tips",
  initialState,
  reducers: {
    resetMessage: (state) => {
      state.message = null;
    },
    setTips(state, action) {
      state.tips = action.payload; // Atualiza a lista de dicas
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(add.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(add.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(getTipsByChallengeId.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getTipsByChallengeId.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.tips = action.payload;
        state.message = "Dicas listadas com sucesso!";
      })
      .addCase(getTipsByChallengeId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteTipsById.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(deleteTipsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteTipsById.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.message = "Dica excluída com sucesso!";
      })
      .addCase(getTipsIndexByChallengeId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTipsIndexByChallengeId.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.tips = action.payload;
        state.message = "Dicas listadas com sucesso!";
      })
      .addCase(getTipsIndexByChallengeId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getTipById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTipById.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.tips = action.payload;
        state.message = "Dicas encontrada com sucesso!";
      })
      .addCase(getTipById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetMessage,setTips } = tipsSlice.actions;
export default tipsSlice.reducer;
